// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-mobile-view {
    display: none;
}

* {
    box-sizing: border-box;
}

.search-function {
    position: fixed;
    left: 610px;
    top: 100px;
    padding: 5px 10px 5px 13px;
    width: 550px;
    height: 50px;
    border-radius: 50px;
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
}

#faq-logo {
    margin-top: 20px;
    height: 38px;
    width: 190px;
    margin-left: 20px;
    cursor: pointer;
    letter-spacing: 0.16px;

}

.accordion-container {
    height: auto;
    width: auto;
    padding: 16px;
}

.accordion-container:last-child {
    border-bottom: none;
}

.accordion-container:not(:last-child) {
    border-bottom: 1px solid #ccc;
}

.accordion-head {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.faq-container {
    height: 886px;
    width: 270px;
    box-shadow: 4px 0 25px 0 rgba(0, 0, 0.12);
}

.topic {
    color: rgba(33, 33, 33, 1);
    font-size: 22px;
    font-weight: 800;
    margin-left: 10px;
    line-height: 20px;
    letter-spacing: 0.16px;
    width: 80px;
    height: 35px;

}

.title-bar {
    display: block;
}

.left-bar {
    border-color: black;
    display: flex;
    flex-direction: column;
    height: 100vh;
    top: 0;
    position: fixed;
    width: 290px;

}

.category-questions h3 {
    position: relative;
    right: 190px;
    width: auto;
    height: 25px;
    font-size: 20px;
    font-weight: 800;
    line-height: 35px;
    letter-spacing: 0.16px;
    color: rgba(33, 33, 33, 1);
    margin-bottom: 40px;
}

.down-arrow {
    display: block;
    height: 5px;
    width: 5px;
}

.contact-bar {
    margin-top: 16px;
    border-color: black;
    height: 125px;
    width: 270px;
    margin-left: 10px;
    text-align: center;
    border-radius: 12px;
    position: fixed;
    z-index: 1000;
    bottom: 10px;
    color: #FFFFFF;
    padding: 0 12px 10px 10px;
    box-sizing: border-box;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.12) !important;;
}

.dropdowns-content {
    flex-grow: 1;
    position: relative;
    top: 0;
    padding: 0;
    margin: 0;
    font-size: 14px;
    height: 460px;
    width: 290px;
    overflow-y: auto;
    overflow-x: hidden;
}
.dropdown-content ::-webkit-scrollbar {
    display: none;
}

.custom-list {
    list-style: none;
    padding-left: 0;
    font-weight: 400;
    font-size: 13px;
    gap: 0;
    position: relative;
    left: 0;
    right: 0;
    padding-top: 13px !important;
    margin-top: 0 !important;

}

.accordion-head {
    font-weight: 600;
    margin-bottom: 0 !important;
}

.accordion-details {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.custom-list li {
    position: relative;
    right: 0;
    display: flex;
    margin-bottom: 8px;
    padding: 10px 10px 3px 5px;
    line-height: 20px;
    letter-spacing: 0.16px;
    color: #212121;
    cursor: pointer;
}

.highlight {
    background-color: #DDEBF8;
    width: 275px;
    border-top-right-radius: 23px;
    border-bottom-right-radius: 23px;
    cursor: pointer;

}

.subsection-link {
    display: flex;
    align-items: center;
    gap: 8px;
}

.custom-list .subsection-link .vector-icon {
    width: 12px;
    height: 12px;
    margin-right: 12px;
}

.FAQ {
    text-align: center;
    position: fixed;
    top: 30px;
    left: 710px;
    font-size: 24px;
    font-weight: 800;
}

.popular-topic {
    text-align: center;
    top: 150px;
    left: 580px;
    font-size: 19px;
    font-weight: 800;
    position: fixed;
    line-height: 35px;
    letter-spacing: 0.16px;
    color: #212121;

}

.topics {
    height: 480px;
    width: 690px;
    margin-left: 540px;
    position: fixed;
    top: 200px;
    display: flex;
    gap: 5px;
}

.topics-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}

.Builder {
    text-align: center;
    height: 220px;
    width: 190px;
    background-color: #F5F5F5;
    border-radius: 12px;
    padding: 5px 10px 8px 10px;
    transition: transform 0.2s;
    cursor: pointer;
}

.popular-topic-description {
    font-size: 14px;
    letter-spacing: 0.16px;
    font-weight: 500;
}

.search-bar {
    position: fixed;
    top: 100px;
    left: 630px;
    width: 33%;
    padding: 5px 0 5px 13px;
    border-radius: 50px;
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);
}

.search-bar:hover {
    background-color: #ffff;
    cursor: pointer;
    color: black;

}

.search-results {
    margin-top: 20px;
    color: black;
    position: fixed;
    top: 160px;
    left: 600px;
    width: 600px;

}

.right-bar {
    width: 70%;
    position: relative;
    z-index: 2;
}

.category-questions {
    text-align: center;
    padding: 20px;
    margin-bottom: 20px;
    position: absolute;
    top: 10px;
    left: 530px;

}

.category-questions ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.category-questions li {
    cursor: pointer;
    padding: 10px 0;
    font-size: 16px;
    border-bottom: 1px solid #eee;
}

.category-list {
    height: 31px;
    width: 600px;
    cursor: pointer;
    padding: 6px 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.16px;
    color: rgba(33, 33, 33, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.search-section h3 {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
}

.search-list {
    list-style-type: none;
    padding-left: 0;

}

.search-list li {
    font-size: 16px;
    padding: 8px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    display: flex;
    align-items: center;

}

.search-icon {
    height: 10px;
    width: 10px;
    position: absolute;
    top: 100px;
    left: 620px;
}

.no-results {
    display: block;
    margin-top: 80px;
    font-size: 20px;
    font-weight: bold;
    margin-left: 245px;


}

.no-results img {
    height: 80px;
    width: 80px;
}

.steps-section {
    display: block;
    margin-left: 530px;
    padding: 20px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: white;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
}
.steps-section::-webkit-scrollbar {
    display: none;
}

.video-container {
    border-radius: 15px;
    position: relative;
    left: 2px;
    top: -10px;

}

.youtube {
    position: relative;
    width: 390px;
    height: 250px;
    cursor: pointer;
    overflow: hidden;
    border-radius: 8px;
    transition: transform 0.3s ease;
}

.iframe-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: background-color 0.3s ease;
    border-radius: 8px;
    z-index: 1;
}

.video-container iframe {
    border-radius: 15px;
}

.youtube iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    z-index: 0;
    border-radius: 8px;
}

.ques-title {
    font-weight: 700;
    font-size: 20px;

}

.device {
    color: #004BA0;
    font-weight: 700;

}

.vector-icon-small {
    margin-right: 8px;
    height: 12px;
    width: 12px;
}

.search-item span {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.16px;
}

.search-item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    padding: 5px;
}

.device {
    font-weight: 700;
    margin-bottom: 5px;
    font-size: 16px;
}

.step-list {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: 800;
    line-height: 22px;
    letter-spacing: 0.16px;
    list-style-type: none !important;

}

.step-list li {
    font-weight: 400;
    margin-bottom: 5px;
    font-size: 14px;
    letter-spacing: 0.16px;
}

.title-and-button {
    display: flex;
}

.copy-link-button {
    display: flex;
    align-items: center;
}

.button-style {
    display: flex;
    align-items: center;
    border-radius: 20px;
    background-color: #EEEEEE;
    color: black;
    padding: 7px 9px;
    border: none;
    cursor: pointer;
}

.link-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
}

.ques-title {
    margin-bottom: 16px;
}

.button-style {
    margin-left: 359px;

}

.right-icon {
    height: 17px;
    width: 17px;
    margin-left: auto;
}

.accordion {
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
}

@media screen and (max-width: 650px) {
    .pc-view {
        display: none;
    }

    .faq-mobile-view {
        display: block;
    }

    .logo {
        position: relative;
        top: 18px;
        left: 99px;
        height: 32px;
        width: 161px;
    }

    .titleBanner {
        padding: 2px 6px 2px 6px
    }

    .left-bar {
        width: 100%

    }

    .no-search {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        padding: 10px;
        line-height: 22px;
        height: 22px;
        width: 172px;
    }

    .category-Content {
        position: relative;
        top: 95px;
        left: 16px;
        border-radius: 12px;
        padding: 1px 0;
        width: 92%;
        height: auto;
        background-color: rgba(245, 245, 245, 1);

    }

    .FAQ {
        position: relative;
        left: 52px;
        top: 10px;
        width: 294px;
        height: 30px;
        font-weight: 700;
        font-size: 22px;
        line-height: 30px;
        letter-spacing: 0.16px;
        text-align: center;
        color: rgba(33, 33, 33, 1);
    }

    .topic {
        width: 54px;
        height: 25px;
        position: absolute;
        top: 152px;
        left: 16px;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0.16px;
        font-weight: 700;
        color: rgba(33, 33, 33, 1);
    }

    .accordionHead {
        font-weight: 600;
    }

    .sticky-Button-Container {
        position: fixed;
        bottom: 65px;
        width: 100%;
        height: 37px;
        left: 260px;
        padding: 0 16px;

    }

    .category-View {
        padding: 20px 10px;
        margin-top: 19px;
    }

    .category-View h2 {
        width: 110px;
        height: 25px;
        position: absolute;
        top: 76px;
        left: 16px;
        font-weight: 700;
        font-size: 18px;
        letter-spacing: 0.16px;
        line-height: 25px;
        color: rgba(33, 33, 33, 1);
    }


    .question-Item {
        position: absolute;
        top: 36px;
        left: 16px;
        border-radius: 12px;
        color: rgba(245, 245, 245, 1)
    }

    .vector-Icon {
        margin-right: 8px;
        width: 14px;
        height: 14px;
    }

    .question-Content {
        width: 95%;
        position: relative;
        top: 55px;
        left: 12px;
        border-radius: 12px;
        background-color: rgba(245, 245, 245, 1);
    }

    .right-arrow-Icon {
        width: 26px;
        height: 26px;
        margin-left: auto;
    }

    .question-Text {
        font-weight: 400;
        width: 256px;;
        height: 19px;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.16px;
        color: rgba(33, 33, 33, 1);
    }

    .question-title {
        width: auto;
        height: 25px;
        position: relative;
        top: 10px;
        left: 16px;
        letter-spacing: 0.16px;
        line-height: 24px;
    }

    .question-steps {
        height: auto;
        position: absolute;
        top: 352px;
        left: 19px;

    }

    .details-Options-Popup button {
        display: flex;
        align-items: center;
        background: none;
        border: none;
    }

    .details-Options-Popup {
        position: absolute;
        top: 50px;
        right: 20px;
        border-radius: 4px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
        padding: 2px 4px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        z-index: 2;
        height: 102px;
        width: 137px;
        font-family: 'Nunito Sans', sans-serif;
    }

    .share-button {
        font-size: 16px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0.16px;
        height: 42px;
        width: 129px;
        display: flex;
        align-items: center;
        padding: 10px 12px 10px 6px;
        gap: 8px;
        border-bottom: 0.5px solid #ccc;
    }

    .copy-button {
        font-size: 16px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0.16px;
        height: 42px;
        width: 129px;
        display: flex;
        align-items: center;
        padding: 10px 10px 10px 2px;
        gap: 8px;
    }

    .question-details {
        position: relative;
        font-weight: 500;
        font-size: 16px;
        color: #333;
        line-height: 24px;
        margin-top: 50px;
    }

    .back-arrow {
        width: 29px;
        height: 29px;
        position: fixed;
        top: 22px;
        left: 16px;
        color: rgba(33, 33, 33, 1);
    }

    .search-category {
        position: fixed;
        left: 20px;
        top: 110px;
        padding: 5px 10px 5px 13px;
        width: 90vw;
        height: 40px;
        border-radius: 25px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
    }

    .search-category.active {
        top: 80px;
    }

    .no-search img {
        height: 48px;
        width: 48px;
    }

    .filter-question-Content {
        margin-top: 98px;
        height: auto;
        border-radius: 12px;
        padding: 6px 10px;
        background-color: transparent;
    }

    .category-list {
        height: 52px;
        width: 100%;
        display: flex;
        padding-left: 8px;
        align-items: center;
        padding-right: 10px;
    }

    .category-list span {
        height: 34px;
        position: relative;
        top: 6px;
        padding: 6px 16px;
        font-weight: 600;
        letter-spacing: 0.16px;
        font-size: 16px;
        color: rgba(33, 33, 33, 1);
        line-height: 21px;

    }

    .category-list img {
        width: 26px;
        height: 26px;
        margin-left: auto;
    }

    .video-overlay {
        position: absolute;
        top: 28px;
        left: 20px;
        border-radius: 12px;
    }

    .video-containers {
        position: relative;
        border-radius: 15px;
        left: -8px;
        top: -2px;
    }

    .step-list {
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.16px;
        font-weight: 400;
        padding:6px;
    }

    .details-icon {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 20px;
        right: 20px;
    }

}`, "",{"version":3,"sources":["webpack://./src/home/css/faq.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,sBAAsB;;AAE1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,MAAM;IACN,eAAe;IACf,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,uDAAuD;AAC3D;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,4BAA4B;IAC5B,wBAAwB;;AAE5B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;IAChC,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;;AAEf;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;;AAGtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,UAAU;AACd;AACA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gCAAgC;;AAEpC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI;IACJ;;IAEA;QACI;;IAEJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB,cAAc;QACd,UAAU;QACV,YAAY;QACZ,wCAAwC;;IAE5C;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,WAAW;QACX,eAAe;;IAEnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,gBAAgB;QAChB,eAAe;QACf,sBAAsB;QACtB,iBAAiB;QACjB,0BAA0B;IAC9B;;;IAGA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB;IACJ;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB,wCAAwC;IAC5C;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,UAAU;;IAEd;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,kBAAkB;QAClB,wCAAwC;QACxC,4CAA4C;QAC5C,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;QACV,aAAa;QACb,YAAY;QACZ,sCAAsC;IAC1C;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,QAAQ;QACR,+BAA+B;IACnC;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,SAAS;QACT,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,UAAU;QACV,UAAU;QACV,0BAA0B;QAC1B,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,0CAA0C;QAC1C,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;QACjB,6BAA6B;IACjC;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,iBAAiB;QACjB,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;QACf,0BAA0B;QAC1B,iBAAiB;;IAErB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,UAAU;QACV,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;AAEJ","sourcesContent":[".faq-mobile-view {\n    display: none;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n.search-function {\n    position: fixed;\n    left: 610px;\n    top: 100px;\n    padding: 5px 10px 5px 13px;\n    width: 550px;\n    height: 50px;\n    border-radius: 50px;\n    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: center;\n}\n\n#faq-logo {\n    margin-top: 20px;\n    height: 38px;\n    width: 190px;\n    margin-left: 20px;\n    cursor: pointer;\n    letter-spacing: 0.16px;\n\n}\n\n.accordion-container {\n    height: auto;\n    width: auto;\n    padding: 16px;\n}\n\n.accordion-container:last-child {\n    border-bottom: none;\n}\n\n.accordion-container:not(:last-child) {\n    border-bottom: 1px solid #ccc;\n}\n\n.accordion-head {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.faq-container {\n    height: 886px;\n    width: 270px;\n    box-shadow: 4px 0 25px 0 rgba(0, 0, 0.12);\n}\n\n.topic {\n    color: rgba(33, 33, 33, 1);\n    font-size: 22px;\n    font-weight: 800;\n    margin-left: 10px;\n    line-height: 20px;\n    letter-spacing: 0.16px;\n    width: 80px;\n    height: 35px;\n\n}\n\n.title-bar {\n    display: block;\n}\n\n.left-bar {\n    border-color: black;\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    top: 0;\n    position: fixed;\n    width: 290px;\n\n}\n\n.category-questions h3 {\n    position: relative;\n    right: 190px;\n    width: auto;\n    height: 25px;\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 35px;\n    letter-spacing: 0.16px;\n    color: rgba(33, 33, 33, 1);\n    margin-bottom: 40px;\n}\n\n.down-arrow {\n    display: block;\n    height: 5px;\n    width: 5px;\n}\n\n.contact-bar {\n    margin-top: 16px;\n    border-color: black;\n    height: 125px;\n    width: 270px;\n    margin-left: 10px;\n    text-align: center;\n    border-radius: 12px;\n    position: fixed;\n    z-index: 1000;\n    bottom: 10px;\n    color: #FFFFFF;\n    padding: 0 12px 10px 10px;\n    box-sizing: border-box;\n    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.12) !important;;\n}\n\n.dropdowns-content {\n    flex-grow: 1;\n    position: relative;\n    top: 0;\n    padding: 0;\n    margin: 0;\n    font-size: 14px;\n    height: 460px;\n    width: 290px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n.dropdown-content ::-webkit-scrollbar {\n    display: none;\n}\n\n.custom-list {\n    list-style: none;\n    padding-left: 0;\n    font-weight: 400;\n    font-size: 13px;\n    gap: 0;\n    position: relative;\n    left: 0;\n    right: 0;\n    padding-top: 13px !important;\n    margin-top: 0 !important;\n\n}\n\n.accordion-head {\n    font-weight: 600;\n    margin-bottom: 0 !important;\n}\n\n.accordion-details {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n}\n\n.custom-list li {\n    position: relative;\n    right: 0;\n    display: flex;\n    margin-bottom: 8px;\n    padding: 10px 10px 3px 5px;\n    line-height: 20px;\n    letter-spacing: 0.16px;\n    color: #212121;\n    cursor: pointer;\n}\n\n.highlight {\n    background-color: #DDEBF8;\n    width: 275px;\n    border-top-right-radius: 23px;\n    border-bottom-right-radius: 23px;\n    cursor: pointer;\n\n}\n\n.subsection-link {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.custom-list .subsection-link .vector-icon {\n    width: 12px;\n    height: 12px;\n    margin-right: 12px;\n}\n\n.FAQ {\n    text-align: center;\n    position: fixed;\n    top: 30px;\n    left: 710px;\n    font-size: 24px;\n    font-weight: 800;\n}\n\n.popular-topic {\n    text-align: center;\n    top: 150px;\n    left: 580px;\n    font-size: 19px;\n    font-weight: 800;\n    position: fixed;\n    line-height: 35px;\n    letter-spacing: 0.16px;\n    color: #212121;\n\n}\n\n.topics {\n    height: 480px;\n    width: 690px;\n    margin-left: 540px;\n    position: fixed;\n    top: 200px;\n    display: flex;\n    gap: 5px;\n}\n\n.topics-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content: center;\n}\n\n.Builder {\n    text-align: center;\n    height: 220px;\n    width: 190px;\n    background-color: #F5F5F5;\n    border-radius: 12px;\n    padding: 5px 10px 8px 10px;\n    transition: transform 0.2s;\n    cursor: pointer;\n}\n\n.popular-topic-description {\n    font-size: 14px;\n    letter-spacing: 0.16px;\n    font-weight: 500;\n}\n\n.search-bar {\n    position: fixed;\n    top: 100px;\n    left: 630px;\n    width: 33%;\n    padding: 5px 0 5px 13px;\n    border-radius: 50px;\n    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);\n}\n\n.search-bar:hover {\n    background-color: #ffff;\n    cursor: pointer;\n    color: black;\n\n}\n\n.search-results {\n    margin-top: 20px;\n    color: black;\n    position: fixed;\n    top: 160px;\n    left: 600px;\n    width: 600px;\n\n}\n\n.right-bar {\n    width: 70%;\n    position: relative;\n    z-index: 2;\n}\n\n.category-questions {\n    text-align: center;\n    padding: 20px;\n    margin-bottom: 20px;\n    position: absolute;\n    top: 10px;\n    left: 530px;\n\n}\n\n.category-questions ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n\n.category-questions li {\n    cursor: pointer;\n    padding: 10px 0;\n    font-size: 16px;\n    border-bottom: 1px solid #eee;\n}\n\n.category-list {\n    height: 31px;\n    width: 600px;\n    cursor: pointer;\n    padding: 6px 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    letter-spacing: 0.16px;\n    color: rgba(33, 33, 33, 1);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.search-section h3 {\n    font-size: 20px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.search-list {\n    list-style-type: none;\n    padding-left: 0;\n\n}\n\n.search-list li {\n    font-size: 16px;\n    padding: 8px;\n    border-bottom: 1px solid #ddd;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n}\n\n.search-icon {\n    height: 10px;\n    width: 10px;\n    position: absolute;\n    top: 100px;\n    left: 620px;\n}\n\n.no-results {\n    display: block;\n    margin-top: 80px;\n    font-size: 20px;\n    font-weight: bold;\n    margin-left: 245px;\n\n\n}\n\n.no-results img {\n    height: 80px;\n    width: 80px;\n}\n\n.steps-section {\n    display: block;\n    margin-left: 530px;\n    padding: 20px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background-color: white;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 2;\n}\n.steps-section::-webkit-scrollbar {\n    display: none;\n}\n\n.video-container {\n    border-radius: 15px;\n    position: relative;\n    left: 2px;\n    top: -10px;\n\n}\n\n.youtube {\n    position: relative;\n    width: 390px;\n    height: 250px;\n    cursor: pointer;\n    overflow: hidden;\n    border-radius: 8px;\n    transition: transform 0.3s ease;\n}\n\n.iframe-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transition: background-color 0.3s ease;\n    border-radius: 8px;\n    z-index: 1;\n}\n\n.video-container iframe {\n    border-radius: 15px;\n}\n\n.youtube iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: none;\n    z-index: 0;\n    border-radius: 8px;\n}\n\n.ques-title {\n    font-weight: 700;\n    font-size: 20px;\n\n}\n\n.device {\n    color: #004BA0;\n    font-weight: 700;\n\n}\n\n.vector-icon-small {\n    margin-right: 8px;\n    height: 12px;\n    width: 12px;\n}\n\n.search-item span {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: 0.16px;\n}\n\n.search-item {\n    display: flex;\n    align-items: center;\n    margin-right: 20px;\n    padding: 5px;\n}\n\n.device {\n    font-weight: 700;\n    margin-bottom: 5px;\n    font-size: 16px;\n}\n\n.step-list {\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 800;\n    line-height: 22px;\n    letter-spacing: 0.16px;\n    list-style-type: none !important;\n\n}\n\n.step-list li {\n    font-weight: 400;\n    margin-bottom: 5px;\n    font-size: 14px;\n    letter-spacing: 0.16px;\n}\n\n.title-and-button {\n    display: flex;\n}\n\n.copy-link-button {\n    display: flex;\n    align-items: center;\n}\n\n.button-style {\n    display: flex;\n    align-items: center;\n    border-radius: 20px;\n    background-color: #EEEEEE;\n    color: black;\n    padding: 7px 9px;\n    border: none;\n    cursor: pointer;\n}\n\n.link-icon {\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n}\n\n.ques-title {\n    margin-bottom: 16px;\n}\n\n.button-style {\n    margin-left: 359px;\n\n}\n\n.right-icon {\n    height: 17px;\n    width: 17px;\n    margin-left: auto;\n}\n\n.accordion {\n    margin: 0 !important;\n    padding: 0 !important;\n    border: none !important;\n}\n\n@media screen and (max-width: 650px) {\n    .pc-view {\n        display: none;\n    }\n\n    .faq-mobile-view {\n        display: block;\n    }\n\n    .logo {\n        position: relative;\n        top: 18px;\n        left: 99px;\n        height: 32px;\n        width: 161px;\n    }\n\n    .titleBanner {\n        padding: 2px 6px 2px 6px\n    }\n\n    .left-bar {\n        width: 100%\n\n    }\n\n    .no-search {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        text-align: center;\n        font-size: 16px;\n        font-weight: 600;\n        color: #333;\n        padding: 10px;\n        line-height: 22px;\n        height: 22px;\n        width: 172px;\n    }\n\n    .category-Content {\n        position: relative;\n        top: 95px;\n        left: 16px;\n        border-radius: 12px;\n        padding: 1px 0;\n        width: 92%;\n        height: auto;\n        background-color: rgba(245, 245, 245, 1);\n\n    }\n\n    .FAQ {\n        position: relative;\n        left: 52px;\n        top: 10px;\n        width: 294px;\n        height: 30px;\n        font-weight: 700;\n        font-size: 22px;\n        line-height: 30px;\n        letter-spacing: 0.16px;\n        text-align: center;\n        color: rgba(33, 33, 33, 1);\n    }\n\n    .topic {\n        width: 54px;\n        height: 25px;\n        position: absolute;\n        top: 152px;\n        left: 16px;\n        font-size: 20px;\n        line-height: 24px;\n        letter-spacing: 0.16px;\n        font-weight: 700;\n        color: rgba(33, 33, 33, 1);\n    }\n\n    .accordionHead {\n        font-weight: 600;\n    }\n\n    .sticky-Button-Container {\n        position: fixed;\n        bottom: 65px;\n        width: 100%;\n        height: 37px;\n        left: 260px;\n        padding: 0 16px;\n\n    }\n\n    .category-View {\n        padding: 20px 10px;\n        margin-top: 19px;\n    }\n\n    .category-View h2 {\n        width: 110px;\n        height: 25px;\n        position: absolute;\n        top: 76px;\n        left: 16px;\n        font-weight: 700;\n        font-size: 18px;\n        letter-spacing: 0.16px;\n        line-height: 25px;\n        color: rgba(33, 33, 33, 1);\n    }\n\n\n    .question-Item {\n        position: absolute;\n        top: 36px;\n        left: 16px;\n        border-radius: 12px;\n        color: rgba(245, 245, 245, 1)\n    }\n\n    .vector-Icon {\n        margin-right: 8px;\n        width: 14px;\n        height: 14px;\n    }\n\n    .question-Content {\n        width: 95%;\n        position: relative;\n        top: 55px;\n        left: 12px;\n        border-radius: 12px;\n        background-color: rgba(245, 245, 245, 1);\n    }\n\n    .right-arrow-Icon {\n        width: 26px;\n        height: 26px;\n        margin-left: auto;\n    }\n\n    .question-Text {\n        font-weight: 400;\n        width: 256px;;\n        height: 19px;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.16px;\n        color: rgba(33, 33, 33, 1);\n    }\n\n    .question-title {\n        width: auto;\n        height: 25px;\n        position: relative;\n        top: 10px;\n        left: 16px;\n        letter-spacing: 0.16px;\n        line-height: 24px;\n    }\n\n    .question-steps {\n        height: auto;\n        position: absolute;\n        top: 352px;\n        left: 19px;\n\n    }\n\n    .details-Options-Popup button {\n        display: flex;\n        align-items: center;\n        background: none;\n        border: none;\n    }\n\n    .details-Options-Popup {\n        position: absolute;\n        top: 50px;\n        right: 20px;\n        border-radius: 4px;\n        background-color: rgba(255, 255, 255, 1);\n        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);\n        padding: 2px 4px;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        z-index: 2;\n        height: 102px;\n        width: 137px;\n        font-family: 'Nunito Sans', sans-serif;\n    }\n\n    .share-button {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 21px;\n        letter-spacing: 0.16px;\n        height: 42px;\n        width: 129px;\n        display: flex;\n        align-items: center;\n        padding: 10px 12px 10px 6px;\n        gap: 8px;\n        border-bottom: 0.5px solid #ccc;\n    }\n\n    .copy-button {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 21px;\n        letter-spacing: 0.16px;\n        height: 42px;\n        width: 129px;\n        display: flex;\n        align-items: center;\n        padding: 10px 10px 10px 2px;\n        gap: 8px;\n    }\n\n    .question-details {\n        position: relative;\n        font-weight: 500;\n        font-size: 16px;\n        color: #333;\n        line-height: 24px;\n        margin-top: 50px;\n    }\n\n    .back-arrow {\n        width: 29px;\n        height: 29px;\n        position: fixed;\n        top: 22px;\n        left: 16px;\n        color: rgba(33, 33, 33, 1);\n    }\n\n    .search-category {\n        position: fixed;\n        left: 20px;\n        top: 110px;\n        padding: 5px 10px 5px 13px;\n        width: 90vw;\n        height: 40px;\n        border-radius: 25px;\n        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);\n        display: flex;\n        justify-content: center;\n    }\n\n    .search-category.active {\n        top: 80px;\n    }\n\n    .no-search img {\n        height: 48px;\n        width: 48px;\n    }\n\n    .filter-question-Content {\n        margin-top: 98px;\n        height: auto;\n        border-radius: 12px;\n        padding: 6px 10px;\n        background-color: transparent;\n    }\n\n    .category-list {\n        height: 52px;\n        width: 100%;\n        display: flex;\n        padding-left: 8px;\n        align-items: center;\n        padding-right: 10px;\n    }\n\n    .category-list span {\n        height: 34px;\n        position: relative;\n        top: 6px;\n        padding: 6px 16px;\n        font-weight: 600;\n        letter-spacing: 0.16px;\n        font-size: 16px;\n        color: rgba(33, 33, 33, 1);\n        line-height: 21px;\n\n    }\n\n    .category-list img {\n        width: 26px;\n        height: 26px;\n        margin-left: auto;\n    }\n\n    .video-overlay {\n        position: absolute;\n        top: 28px;\n        left: 20px;\n        border-radius: 12px;\n    }\n\n    .video-containers {\n        position: relative;\n        border-radius: 15px;\n        left: -8px;\n        top: -2px;\n    }\n\n    .step-list {\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.16px;\n        font-weight: 400;\n        padding:6px;\n    }\n\n    .details-icon {\n        width: 20px;\n        height: 20px;\n        position: absolute;\n        top: 20px;\n        right: 20px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
